import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"bg-sheet pb-5"},[_c(VContainer,{staticClass:"py-6 py-lg-12 text-center"},[_c('h1',{staticClass:"text-h4 text-sm-h3 text-md-h2 text-lg-h1 mt-md-6"},[_vm._v("My Flying Manager"),_c('span',{staticClass:"primary--text"},[_vm._v(".aero")])]),_c('h2',{staticClass:"text-h6 text-sm-h5 text--lighten-2 mt-4"},[_vm._v("Online management for flying organisations")]),_c(VImg,{staticClass:"rounded elevation-3 mb-6",attrs:{"src":"","alt":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }